import React, { FC } from 'react';
import { TextField } from '@material-ui/core';
import { WrappedFieldProps } from 'redux-form';
import i18n from '../../../i18n';
import MaskedInput from 'react-text-mask';
import { createNumberMask } from 'text-mask-addons';

export interface QuantityControlProps {
    label: string;
    // Optional:
    name?: string;
    value?: string;
    onChange?: any;
    error?: string;
    fullWidth?: boolean;
    isDisabled?: boolean;
    className?: string;
    inputClassName?: string;
}

interface QuantityMaskInputProps {
    inputRef: (ref: HTMLInputElement | null) => void;
}

const quantityMask = createNumberMask({
    prefix: '',
    includeThousandsSeparator: false,
    allowDecimal: true,
});

function QuantityMaskInput(props: QuantityMaskInputProps) {
    const { inputRef, ...rest } = props;
    return (
        <MaskedInput
            {...rest}
            ref={(ref: any) => {
                inputRef(ref ? ref.inputElement : null);
            }}
            mask={quantityMask}
        />
    );
}

export const QuantityControl: FC<QuantityControlProps> = props => {
    const { error, className, inputClassName, ...rest } = props;

    return (
        <TextField
            InputProps={{
                disableUnderline: true,
                inputComponent: QuantityMaskInput as any,
                className: inputClassName,
            }}
            className={className}
            variant="filled"
            error={!!error}
            helperText={error}
            fullWidth={true}
            size="small"
            {...rest}
        />
    );
};

export interface QuantityControlFieldOwnProps {
    label: string;
    className?: string;
    inputClassName?: string;
}

export type QuantityControlFieldProps = QuantityControlFieldOwnProps & WrappedFieldProps;

export const QuantityControlField = (props: QuantityControlFieldProps) => {
    const { t } = i18n.useTranslation();
    const {
        input,
        label,
        className,
        inputClassName,
        meta: { touched, invalid, error },
    } = props;

    return (
        <QuantityControl
            label={label}
            className={className}
            inputClassName={inputClassName}
            error={touched && invalid ? t(error) : undefined}
            {...input}
        />
    );
};
